import { MChatPerguntaEnum, MChatRfPerguntaRespostaInput } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'

import { convertPodeNaoPodeEnumToBoolean, convertSimNaoEnumToBoolean } from '../../converter-consultaSeguimento'
import { ConsultaSeguimentoPergunta18Model } from './model-consultaSeguimentoPergunta18'

export const convertConsultaSeguimentoPergunta18ToInput = (
  value: ConsultaSeguimentoPergunta18Model
): Array<MChatRfPerguntaRespostaInput> => {
  const caminho: MChatRfPerguntaRespostaInput[] = [
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_18_01,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_18_HEADER),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_18_02,
      stResposta: convertPodeNaoPodeEnumToBoolean(value.PERGUNTA_18_PODE_NAO_PODE),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_18_03,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_18_TEM_DICA_SEGUE_ORDEM),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_18_04,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_18_SENTA_A_MESA),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_18_05,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_18_EXEMPLOS?.SEM_DICA_MOSTRA_SAPATO),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_18_06,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_18_EXEMPLOS?.SEM_DICA_TRAZ_COBERTOR),
    },
    {
      pergunta: MChatPerguntaEnum.PERGUNTA_18_07,
      stResposta: convertSimNaoEnumToBoolean(value.PERGUNTA_18_EXEMPLOS?.SEM_DICA_POE_LIVRO_CADEIRA),
    },
  ]

  return caminho.filter((item) => !isUndefinedOrNull(item.stResposta))
}
